import { render, staticRenderFns } from "./OidcRedirect.vue?vue&type=template&id=2cdafd8f"
import script from "./OidcRedirect.vue?vue&type=script&lang=js"
export * from "./OidcRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\.jenkins\\workspace\\tplt.10ndata.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cdafd8f')) {
      api.createRecord('2cdafd8f', component.options)
    } else {
      api.reload('2cdafd8f', component.options)
    }
    module.hot.accept("./OidcRedirect.vue?vue&type=template&id=2cdafd8f", function () {
      api.rerender('2cdafd8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OidcRedirect.vue"
export default component.exports